import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AccountSettings from './AccountSettings';
import PropertiesManagement from './PropertiesManagement';

const Settings = () => {
    return (
        <div className="h-full flex flex-col">
            {/* Content Area - Navigation is now handled by the Sidebar */}
            <div className="flex-1 min-h-0 overflow-auto scrollbar-hide">
                <Routes>
                    <Route index element={<Navigate to="account" replace />} />
                    <Route path="account" element={<AccountSettings />} />
                    <Route path="properties" element={<PropertiesManagement />} />
                </Routes>
            </div>
        </div>
    );
};

export default Settings;
